// モーダルデフォルトラベル
export const LABELS = {
  TITLE: "確認",
  CANCEL: "キャンセル",
  OK: "OK",
} as const;
